import { Route, Routes } from "react-router";
import SmartViewAppPage from "./SmartViewAppPage";
import UiReportsContainer from "./components/ReportsContainer";
import { EditRoot as UiEditRoot } from "./components/builder/EditRoot";
import UiViewRoot from "./components/builder/ViewRoot";

const SmartViewUiReportPage = () => {
  return (
    <Routes>
      <Route element={<SmartViewAppPage />}>
        <Route element={<UiReportsContainer />}>
          <Route path=":id/view" element={<UiViewRoot />} />
          <Route path=":id/edit" element={<UiEditRoot />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default SmartViewUiReportPage;
